import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Loan } from 'src/app/models/loan';
import { ContractReturnResponseCompleteModel } from 'src/app/models/response/contract-return-response-complete-model';
import { LoanService } from 'src/app/services/loan.service';

@Component({
  selector: 'app-stand-alone-return-contract',
  templateUrl: './stand-alone-return-contract.component.html',
  styleUrls: ['./stand-alone-return-contract.component.sass'],
})
export class StandAloneReturnContractComponent implements OnInit {
  loan: Loan = new Loan();
  constructor(
    private route: ActivatedRoute,
    private loanService: LoanService,
    private router: Router
  ) { }

  async ngOnInit(): Promise<void> {
    const contractNumber = this.route.snapshot.params.contractNumber;

    if (contractNumber) {
      const getLoanResponse = (await this.loanService
        .getLoansByFilters({
          page: 0,
          pageSize: 100,
          value: { contractNumber },
        })
        .toPromise());
      if (getLoanResponse.response.length > 0) {
        console.log(getLoanResponse);

        this.loan = getLoanResponse.response[0];
      }
    }
  }

  handleReturnComplete(
    responseReturnContract: ContractReturnResponseCompleteModel
  ) {
    this.router.navigate(
      [`customer/returnContractDetail`, this.loan.contractNumber]
    );
  }
}
